export default function pathName(pathName) {
  let name = pathName.split('/').filter(Boolean);

  if (name.length === 1) return name[0];

  if (name.length >= 1) return name.join(' ');

  return '';
}
